<template>
  <div class="container-fluid u-padding-0">
    <div v-if="isLoading" class="o-card">
      <loading></loading>
    </div>
    <no-auth v-else-if="!hasAuthorize.getById"></no-auth>
    <div class="o-card" v-else-if="!project">
      <LockedView>
        <div>
          {{ $t("projectDetail.notFound") }}
        </div>
        <div class="u-margin-top">
          <router-link :to="{ name: 'main-projects' }">
            <Button variant="primary">
              <i class="icofont-arrow-left"></i> {{ $t("common.back") }}
            </Button>
          </router-link>
        </div>
      </LockedView>
    </div>
    <div class="row row-no-gutters" v-else>
      <div class="es-xs-12 u-padding-bottom-xsmall es-lg-8 es-xl-9">
        <div>
          <div class="row u-margin-left-0 u-margin-right-0">
            <div
              v-if="!project.isActive"
              class="es-xs-12 u-padding-bottom-xsmall"
            >
              <IsOldLogBar
                @refresh="getProject(true)"
                :project="project"
              ></IsOldLogBar>

              <IsLockedItem
                v-if="project.isLocked"
                :project="project"
              ></IsLockedItem>
            </div>
            <div
              class="es-xs-12 u-padding-bottom-xsmall u-padding-left-0 u-padding-0 es-lg-12"
            >
              <ProjectInfo
                in-detail
                class="o-card"
                :project="project"
              ></ProjectInfo>
            </div>
            <div class="es-xs-12 u-padding-bottom-xsmall">
              <ProjectTabs :project="project" @refresh="refresh"></ProjectTabs>
            </div>
          </div>
        </div>
      </div>
      <div
        class="es-xs-12 col-sticky u-top-0 es-lg-4 es-xl-3 u-padding-bottom-xsmall u-padding-left-xsmall"
      >
        <ActionBar
          @refresh="getProject(true)"
          class="u-margin-bottom-small"
          :project="project"
        ></ActionBar>
        <ProjectInfoVertical :project="project"></ProjectInfoVertical>
      </div>
    </div>
  </div>
</template>

<script>
import ActionBar from "./ActionBar.vue";
import ProjectTabs from "./Tabs/ProjectTabs.vue";
import IsOldLogBar from "./IsOldLogBar.vue";
import LockedView from "../LockedView/index.vue";
import Loading from "../Base/Loading/Loading.vue";
import Button from "../Base/Button.vue";
import IsLockedItem from "./IsLocked.vue";
import ProjectInfo from "./ProjectInfo.vue";
import ProjectInfoVertical from "./ProjectInfoVertical.vue";
import authorize from "../Projects/authorize";

export default {
  mixins: [authorize],
  components: {
    ProjectInfo,
    LockedView,
    ActionBar,
    ProjectTabs,
    IsOldLogBar,
    Loading,
    Button,
    IsLockedItem,
    ProjectInfoVertical,
  },
  data() {
    return {
      project: null,
      isLoading: true,
    };
  },
  methods: {
    async getProject(force = false) {
      this.isLoading = true;
      console.log(this.$route.params.projectId, "this.$route.params.projectId");

      const response = await this.$store.dispatch("getProjectById", {
        id: this.$route.params.projectId,
        force: force,
      });
      if (response.message === "OK") {
        if (!response.data) return (this.isLoading = false);
        const data = response.data || {};
        const batteries = response.data?.batteryInfo || [];
        const evaporatorBatteryId =
          batteries.find((b) => b.type === "Evaporator") || null;
        const condenserBatteryId =
          batteries.find((b) => b.type === "Condenser") || null;
        this.project = {
          ...data,
          refrigerantId: data?.refrigerantInfo,
          compressorBrandId: data?.compressorBrandInfo,
          brandRefrigerantId: data?.compressorBrandRefrigerantInfo,
          refrigerantModelId: data?.compressorRefrigerantModelInfo,
          evaporatorBatteryId: evaporatorBatteryId,
          condenserBatteryId: condenserBatteryId,
          evaporatorAirflow: evaporatorBatteryId
            ? evaporatorBatteryId?.airflow
            : null,
          condenserAirflow: condenserBatteryId
            ? condenserBatteryId?.airflow
            : null,
          condenserCount: condenserBatteryId
            ? {
                value: condenserBatteryId?.count,
                name: condenserBatteryId?.count,
              }
            : null,
          compressorCount: data?.compressorCount
            ? {
                value: data?.compressorCount,
                name: data?.compressorCount,
              }
            : null,
          superheat: evaporatorBatteryId
            ? evaporatorBatteryId?.superheat
            : null,
          subcooling: evaporatorBatteryId
            ? evaporatorBatteryId?.subcooling
            : null,
        };
      }
      this.isLoading = false;
    },
    refresh() {
      this.getProject(true);
    },
  },
  mounted() {
    this.getProject();
  },
};
</script>

<style></style>
